import {
  ExpressionNodeType,
  ExpressionPayloadType,
} from "@intelligems/ig-types";

// @ts-ignore
const expressionListToInfix = (
  expressionsList: ExpressionPayloadType[]
): ExpressionNodeType[] => {
  const infix: ExpressionNodeType[] = [];
  for (const expression of expressionsList) {
    const queries = expression.queries;
    if (queries.length) {
      infix.push({ operator: "start_paren" });
      for (const queryIndex in queries) {
        const query = queries[queryIndex];
        infix.push({ query });
        // if not last item in array, push an 'or' operator
        if (parseInt(queryIndex) !== queries.length - 1) {
          infix.push({ operator: "or" });
        }
      }
      infix.push({ operator: "end_paren" });
      // if not last item in array, push an 'and' operator
      if (expressionsList.indexOf(expression) !== expressionsList.length - 1) {
        infix.push({ operator: "and" });
      }
    }
  }
  return infix;
};

// if we added more layers of nesting, or the ability to add 'and' within a block, we'd need to modify
// but this works great for current logic
const infixToExpressionList = (
  infix: ExpressionNodeType[]
): ExpressionPayloadType[] => {
  const expressionsList: ExpressionPayloadType[] = [];
  let payload: ExpressionPayloadType | null = null;
  for (let i = 0; i < infix.length; i++) {
    const curr = infix[i];
    if (curr.query) {
      if (!payload)
        payload = {
          type: curr.query.type,
          queries: [curr.query],
        };
      else payload.queries.push(curr.query);
    } else if (curr.operator === "and" && payload) {
      expressionsList.push(payload);
      payload = null;
    }
  }
  if (payload) expressionsList.push(payload);
  return expressionsList;
};

export const postfixToInfix = (
  postfix: ExpressionNodeType[]
): ExpressionNodeType[] => {
  const stack: ExpressionNodeType[][] = [[]];
  for (let i = 0; i < postfix.length; i++) {
    const curr = postfix[i];
    if (postfix[i].query) {
      stack.push([curr]);
    } else {
      const op1 = stack[stack.length - 1];
      stack.pop();
      const op2 = stack[stack.length - 1];
      stack.pop();
      stack.push([
        { operator: "start_paren" },
        ...op2,
        postfix[i],
        ...op1,
        { operator: "end_paren" },
      ]);
    }
  }
  return stack[stack.length - 1];
};

const infixToPostfix = (infix: ExpressionNodeType[]): ExpressionNodeType[] => {
  const postfix: ExpressionNodeType[] = [];
  const stack: ExpressionNodeType[] = [];
  for (const token of infix) {
    if (token.query) {
      postfix.push(token);
    } else if (token.operator === "start_paren") {
      stack.push(token);
    } else if (token.operator === "end_paren") {
      while (
        stack.length &&
        stack[stack.length - 1].operator !== "start_paren"
      ) {
        postfix.push(stack.pop() as ExpressionNodeType);
      }
      stack.pop();
    } else {
      while (
        stack.length &&
        (stack[stack.length - 1].operator === "and" ||
          stack[stack.length - 1].operator === "or")
      ) {
        postfix.push(stack.pop() as ExpressionNodeType);
      }
      stack.push(token);
    }
  }
  while (stack.length) {
    postfix.push(stack.pop() as ExpressionNodeType);
  }
  return postfix;
};

export const postfixToExpressionList = (
  postfix: ExpressionNodeType[]
): ExpressionPayloadType[] => {
  const infix: ExpressionNodeType[] = postfixToInfix(postfix);
  const expressionsList: ExpressionPayloadType[] = infixToExpressionList(infix);
  return expressionsList;
};

export const expressionListToPostFix = (
  expressionsList: ExpressionPayloadType[]
): ExpressionNodeType[] => {
  const infix: ExpressionNodeType[] = expressionListToInfix(expressionsList);
  // convert infix to postfix, 'or' and 'and' are operators and 'start_paren' and 'end_paren' are parenthesis
  const postfix: ExpressionNodeType[] = infixToPostfix(infix);
  return postfix;
};
